import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { ViewStatus } from '@ubie/core';

@Component({
    selector: 'shared-view-state-container',
    templateUrl: './view-state-container.component.html',
    styleUrl: './view-state-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ViewStateContainerComponent {
  ViewStatus = ViewStatus;
  @Input() state = ViewStatus.Loading;
  @Input() loaderTemplate: TemplateRef<any> | null = null;
  @Input() rejectedTemplate: TemplateRef<any> | null = null;
  @Input() hasRetryButton = false;
  @Output() readonly retry = new EventEmitter<void>();

  onRetry(): void {
    this.retry.emit();
  }
}
